import { render } from "./PaperWithSvg.vue?vue&type=template&id=d942f12a"
import script from "./PaperWithSvg.vue?vue&type=script&lang=js"
export * from "./PaperWithSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__